import { connectEmptyApi } from '@app/api/connect-empty-api';
import { Action, combineReducers, configureStore, ThunkAction } from '@reduxjs/toolkit';
import authReducer from './reducers/authSlice';
import stubReducer from './reducers/stubSlice';

const rootReducer = combineReducers({
  [connectEmptyApi.reducerPath]: connectEmptyApi.reducer,
  authReducer,
  stubReducer,
});

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const setupStore = () =>
  configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware: any) => getDefaultMiddleware().concat([connectEmptyApi.middleware]),
  });

export type RootState = ReturnType<typeof rootReducer>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore['dispatch'];
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;
